// Hooks
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { FaXmark } from "react-icons/fa6";

// Assets
import { BurguerMenu, Moon, Sun } from "src/assets/svgs";
import { collapseSide } from "src/store/context/reducer";
import { setPreviewTheme } from "src/store/config/reducer";
import { NetworkStatus } from "src/types";
import Tooltip from "src/components/tooltip";

function SwitchDarkMode() {
  const { general } = useAppSelector((state) => state.config);
  const dispatch = useAppDispatch();

  const isDark = general.theme === "dark";

  const handleThemeSwitch = () => dispatch(setPreviewTheme(isDark ? "light" : "dark"));

  return (
    <button onClick={handleThemeSwitch} className="bg-neutral-gray-5 p-2 rounded-lg flex dark:bg-[#434359] gap-2">
      <div className={`rounded-lg flex items-center justify-center p-2 ${!isDark ? "bg-primary-blue-400 dark:bg-primitive-blue-500" : ""}`}>
        <Sun className={`dark:fill-white w-[18px] h-[18px] ${!isDark ? "fill-white" : "fill-neutral-gray-600"}`} />
      </div>

      <div className={`${isDark ? "bg-primary-blue-400 dark:bg-primitive-blue-500" : ""} rounded-lg p-2 flex items-center justify-center`}>
        <Moon className={`${isDark ? "fill-white" : "fill-neutral-gray-600"}  w-[18px] h-[18px]`} />
      </div>
    </button>
  );
}

export default function Topbar() {
  const { userInfo } = useAppSelector((state) => state.auth);
  const { sidebarCollapsed, network } = useAppSelector((state) => state.context);
  const dispatch = useAppDispatch();

  const BurguerIcon = !sidebarCollapsed ? BurguerMenu : FaXmark;

  const networkColorRef = {
    [NetworkStatus.ONLINE]: "bg-lime-400",
    [NetworkStatus.UNSTABLE]: "bg-orange-400",
    [NetworkStatus.OFFLINE]: "bg-neutral-gray-400",
  };

  const networkTooltipRef = {
    [NetworkStatus.ONLINE]: "Online e ativo para recebimento de chamadas.",
    [NetworkStatus.UNSTABLE]: "Conexão lenta e instável.",
    [NetworkStatus.OFFLINE]: "Offline e inativo para recebimento de chamadas.",
  };

  return (
    <aside className="flex items-center w-full py-4 px-8">
      <button type="button" onClick={() => dispatch(collapseSide())} className="dark:bg-neutral-gray-800 bg-neutral-gray-5 rounded-md p-3">
        <BurguerIcon size="24" className="dark:fill-neutral-gray-50 dark:stroke-neutral-gray-50 fill-neutral-gray-600 stroke-neutral-gray-600" />
      </button>

      <nav className="ml-auto">
        <div className="avatar-btn flex gap-6 items-center">
          {/* <img src={Avatar} className="rounded-md" width="40" alt="avatar" /> */}
          <SwitchDarkMode />

          <div className="dark:text-neutral-gray-500 flex flex-col items-start text-neutral-gray-600">
            <strong className="dark:text-neutral-gray-50 text-base text-neutral-gray-700 flex items-center gap-2">
              {userInfo?.name}
              <Tooltip text={networkTooltipRef[network.status]}>
                <span className={`w-2 h-2 block rounded-full ${networkColorRef[network.status]}`}></span>
              </Tooltip>
            </strong>
            {userInfo?.email}
          </div>
        </div>
      </nav>
    </aside>
  );
}
